(function () {
  function isAdventureTimeLive(config) {
    var launchMs = Date.parse(config.launchAt);
    return !Number.isNaN(launchMs) && Date.now() >= launchMs;
  }

  function getCurrentPath(config) {
    return isAdventureTimeLive(config)
      ? config.currentPathAfterLaunch
      : config.currentPathBeforeLaunch;
  }

  function getVisibleExperiences(config) {
    var live = isAdventureTimeLive(config);
    return config.experiences.filter(function (exp) {
      if (!live && exp.path === config.currentPathAfterLaunch) return false;
      return true;
    });
  }

  function getOrderedItems(config) {
    var currentPath = getCurrentPath(config);
    var base = config.baseUrl;
    return getVisibleExperiences(config).map(function (exp) {
      return {
        label: exp.label,
        href: base + exp.path,
        isCurrent: exp.path === currentPath,
      };
    });
  }

  function initRevivedMenu() {
    var toggle = document.getElementById('revivedMenuToggle');
    var submenu = document.getElementById('revivedSubmenu');
    if (!toggle || !submenu) return;

    fetch(window.ASSPIZZA_REVIVED_MENU_URL)
      .then(function (res) {
        return res.json();
      })
      .then(function (config) {
        var items = getOrderedItems(config);
        submenu.innerHTML = items
          .map(function (item) {
            var currentClass = item.isCurrent ? ' side-menu__revived-link--current' : '';
            return (
              '<li><a class="side-menu__revived-link' +
              currentClass +
              '" href="' +
              item.href +
              '">' +
              item.label +
              '</a></li>'
            );
          })
          .join('');
      })
      .catch(function () {
        toggle.setAttribute('hidden', 'hidden');
      });

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (isOpen) {
        submenu.setAttribute('hidden', 'hidden');
      } else {
        submenu.removeAttribute('hidden');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRevivedMenu);
  } else {
    initRevivedMenu();
  }
})();
